import { Codebook } from '../Codebook'
import { CountryId } from '../country/CountryId'

export enum B2bInvoicerId {
  PREVIO_HU = 1,
  PREVIO_SK = 2,
  PREVIO_CZ = 3,
  PREVIO_PL = 4,
  PREVIO_RO = 6,
}

export class B2bInvoicer extends Codebook<B2bInvoicerId> {
  static readonly PREVIO_HU = new B2bInvoicer(B2bInvoicerId.PREVIO_HU, 'Previo HU', CountryId.HUN)
  static readonly PREVIO_SK = new B2bInvoicer(B2bInvoicerId.PREVIO_SK, 'Previo SK', CountryId.SVK)
  static readonly PREVIO_CZ = new B2bInvoicer(B2bInvoicerId.PREVIO_CZ, 'Previo CZ', CountryId.CZE)
  static readonly PREVIO_PL = new B2bInvoicer(B2bInvoicerId.PREVIO_PL, 'Previo PL', CountryId.POL)
  static readonly PREVIO_RO = new B2bInvoicer(B2bInvoicerId.PREVIO_RO, 'Previo RO', CountryId.ROU)

  static getDefault(countryId: CountryId | null): B2bInvoicer {
    return (
      B2bInvoicer.all().find((invoicer) => invoicer.countryId === countryId) ??
      B2bInvoicer.PREVIO_CZ
    )
  }

  private constructor(
    id: B2bInvoicerId,
    public readonly name: string,
    public readonly countryId: CountryId,
  ) {
    super(id)
  }
}
